var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2CDA4B53-347F-4990-8232-55F0F0FFA634") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.3480501,33.1041896 L24.544459,43.3005985 C25.484228,44.2403675 25.4825286,45.7613319 24.544459,46.6994015 L14.3480501,56.8958104 C13.4099805,57.83388 11.8890162,57.8355794 10.9492472,56.8958104 L0.752838282,46.6994015 C-0.186930737,45.7596325 -0.185231336,44.2386681 0.752838282,43.3005985 L10.9492472,33.1041896 C11.8873168,32.16612 13.4082811,32.1644206 14.3480501,33.1041896 Z M14.3480501,0.704189633 L24.544459,10.9005985 C25.484228,11.8403675 25.4825286,13.3613319 24.544459,14.2994015 L14.3480501,24.4958104 C13.4099805,25.43388 11.8890162,25.4355794 10.9492472,24.4958104 L0.752838282,14.2994015 C-0.186930737,13.3596325 -0.185231336,11.8386681 0.752838282,10.9005985 L10.9492472,0.704189633 C11.8873168,-0.233879985 13.4082811,-0.235579386 14.3480501,0.704189633 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3480501,0.787474564 L24.544459,10.9838835 C25.4825286,11.9219531 25.484228,13.4429174 24.544459,14.3826864 L14.3480501,24.5790953 C13.4082811,25.5188643 11.8873168,25.5171649 10.9492472,24.5790953 L0.752838282,14.3826864 C-0.185231336,13.4446168 -0.186930737,11.9236525 0.752838282,10.9838835 L10.9492472,0.787474564 C11.8890162,-0.152294455 13.4099805,-0.150595054 14.3480501,0.787474564 Z M46.7480501,0.787474564 L56.944459,10.9838835 C57.8825286,11.9219531 57.884228,13.4429174 56.944459,14.3826864 L46.7480501,24.5790953 C45.8082811,25.5188643 44.2873168,25.5171649 43.3492472,24.5790953 L33.1528383,14.3826864 C32.2147687,13.4446168 32.2130693,11.9236525 33.1528383,10.9838835 L43.3492472,0.787474564 C44.2890162,-0.152294455 45.8099805,-0.150595054 46.7480501,0.787474564 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.2-WebPageBuilder-EmptyWidgets",
    transform: "translate(-1104.000000, -706.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Treemap",
    transform: "translate(892.000000, 536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Undefined/40dp",
    transform: "translate(212.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(23.400000, 7.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.400000, -7.102703)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(7.200000, 23.316715)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.200000, -23.219418)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.9bf3aa1683c768ae300563199310025d.svg";
export { ForwardRef as ReactComponent };